export const columns = {
    ADDRESS_STATUS: 'addressStatus',
    TOTAL_SHAREHOLDERS_PERCENT: 'openAccountsPercent',
    COUNTRY: 'country',
    STATE: 'state',
    BAD_ADDRESSES_NUMBER: 'badAddressesNumber',
    LABEL: 'label'
};
